import React__default from 'react';
import InfoCircleFilled from '../../../icons/InfoCircleFilled.js';
import CheckCircleFilled from '../../../icons/CheckCircleFilled.js';
import AlertTriangle from '../../../icons/AlertTriangle.js';
import AlertCircle from '../../../icons/AlertCircle.js';

function ToastIcon({ variant, }) {
    switch (variant) {
        case 'info':
            return React__default.createElement(InfoCircleFilled, null);
        case 'positive':
            return React__default.createElement(CheckCircleFilled, null);
        case 'warning':
            return React__default.createElement(AlertTriangle, null);
        case 'error':
            return React__default.createElement(AlertCircle, null);
        default:
            return React__default.createElement(React__default.Fragment, null);
    }
}

export { ToastIcon as default };
